// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TB50","question":"styles_question__3oqVZ","description":"styles_description__ZZ7A3"};